
import { defineComponent } from 'vue'
export default defineComponent({
  setup() {
    const handleGoAgreement = (type: string) => {
      const url = `${location.origin}/vshow-main/#/${type}`
      window.open(url)
    }
    return {
      handleGoAgreement,
    }
  },
})
